import TmsTypeBoolean from "./boolean.vue";
import TmsTypeColor from "./color.vue";
import TmsTypeCustom from "./custom.vue";
import TmsTypeCustomList from "./customList.vue";
import TmsTypeImg from "./img.vue";
import TmsTypeSmallImg from "./smallImg.vue";
import TmsTypeImgSet from "./imgSet.vue";
import TmsTypeImgLink from "./imgLink.vue";
import TmsTypeImgLinkList from "./imgLinkList.vue";
import TmsTypeLink from "./link.vue";
import TmsTypeNumber from "./number.vue";
import TmsTypeHeight from "./height.vue";
import TmsTypeRadioBox from "./radioBox.vue";
import TmsTypeDatePickerBox from "./datePickerBox.vue";
import TmsTypeRadioBoxImg from "./radioBoxImg.vue";
import TmsTypeRadioBoxImgSet from "./radioBoxImgSet.vue";
import TmsTypeRichText from "./richText.vue";
import TmsTypeSelect from "./select.vue";
import TmsTypeText from "./text.vue";
import TmsTypeTextarea from "./textarea.vue";
import TmsTypeVideo from "./video.vue";
import TmsTypeAudio from "./audio.vue";
import TmsTypeMiddleNav from "./middleNav.vue";
import TmsTypeTopNav from "./topNav.vue";
import TmsTypeBottomNav from "./bottomNav.vue";
import TmsTypeCustomerService from "./customerService.vue";
import TmsTypeCustomMenu from "./customMenu.vue";
import TmsTypeForm from "./form.vue";
import TmsTypeArticleList from "./articleList.vue";
import TmsTypeItem from "./item.vue";
import TmsTypeActiveGoodsItem from "./activeGoodsItem.vue";
import TmsTypeItemSale from "./itemSale.vue";
import TmsTypeSelectActive from "./selectActive.vue";
import TmsTypeServiceList from "./serviceList.vue";
import TmsTypeServiceSale from "./serviceSale.vue";
import TmsTypeShopList from "./shopList.vue";
import TmsTypeAddress from "./address.vue";
import TmsTypeNoticeBoard from "./noticeBoard.vue";
import TmsTypePageBackground from "./pageBackground.vue";
import TmsTypeShopHeader from "./shopHeader.vue";
import TmsTypePersonalInfo from "./personalInfo.vue";
import TmsTypeTips from "./tips.vue";
import TmsTypeModuleName from "./moduleName.vue";
import TmsTypeRedPackets from "./redPackets.vue";
import TmsTypeRadioBoxInput from "./radioBoxInput.vue";
import TmsTypeCheckboxList from "./checkboxList.vue";
import TmsTypeFormGroupList from "./formGroupList.vue";
import TmsTypeBargainList from "./bargainList.vue";
import TmsTypeJumpApp from "./jumpApp.vue";
import TmsTypeSelectRule from "./selectRule.vue";
import TmsTypeBottomFloat from "./bottomFloat";
import TmsTypeChoosePhoto from "./choose-photo.vue";
import TmsTypeGradientColor from "./gradientColor.vue";
import TmsTypeUploadData from "./uploadData.vue";
import TmsTypeSwiperNav from "./swiperNav";
import TmsTypeSlider from "./slider";
export {
    TmsTypeSlider,
    TmsTypeSwiperNav,
    TmsTypeGradientColor,
    TmsTypeUploadData,
    TmsTypeChoosePhoto,
    TmsTypeBoolean,
    TmsTypeColor,
    TmsTypeCustom,
    TmsTypeCustomList,
    TmsTypeImg,
    TmsTypeSmallImg,
    TmsTypeImgSet,
    TmsTypeImgLink,
    TmsTypeImgLinkList,
    TmsTypeLink,
    TmsTypeNumber,
    TmsTypeHeight,
    TmsTypeRadioBox,
    TmsTypeDatePickerBox,
    TmsTypeRadioBoxImg,
    TmsTypeRadioBoxImgSet,
    TmsTypeRichText,
    TmsTypeSelect,
    TmsTypeText,
    TmsTypeTextarea,
    TmsTypeVideo,
    TmsTypeAudio,
    TmsTypeMiddleNav,
    TmsTypeTopNav,
    TmsTypeBottomNav,
    TmsTypeCustomerService,
    TmsTypeCustomMenu,
    TmsTypeForm,
    TmsTypeArticleList,
    TmsTypeItem,
    TmsTypeItemSale,
    TmsTypeServiceList,
    TmsTypeServiceSale,
    TmsTypeShopList,
    TmsTypeAddress,
    TmsTypeNoticeBoard,
    TmsTypePageBackground,
    TmsTypeShopHeader,
    TmsTypePersonalInfo,
    TmsTypeTips,
    TmsTypeModuleName,
    TmsTypeRedPackets,
    TmsTypeRadioBoxInput,
    TmsTypeCheckboxList,
    TmsTypeFormGroupList,
    TmsTypeBargainList,
    TmsTypeSelectActive,
    TmsTypeActiveGoodsItem,
    TmsTypeJumpApp,
    TmsTypeSelectRule,
    TmsTypeBottomFloat
};